/* eslint-disable */
import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import SideBar from './SideBar'
import useCollapse from 'react-collapsed'
import Swal from 'sweetalert2'
import {
  FaRegEdit, FaRegTrashAlt
} from 'react-icons/fa'
import apiInstance from '../../utils/api'

function Dashboard() {
  const [showUpdate, setShowUpdate] = useState(false)
  const [supplierList, setSupplierList] = useState([])
  const [id, setId] = useState('')
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    address: "",
  })

  const SupplierCreate = async () => {

    // console.log(formData, 'afs')
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    await apiInstance
      .post(
        'supplier',
        formData,
        config
      )
      .then(function (response) {
        Swal.fire({
          title: "Successful!",
          text: "You Created Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
        // alert("success");
        setSupplierList([...supplierList, response.data.data])
      })
      .catch(function (err) {
        alert(err.message)
      })
    // document.getElementById('description').value = ''
    // document.getElementById('name').value = ''
    //      props.setOpen(false);
  }

  const SupplierUpdate = async () => {

    console.log(formData, 'afs')
    if (id) formData.id = id
    const config = {
      headers: { 'Content-Type': 'application/json' }
    }
    await apiInstance
      .put(
        'supplier',
        formData,
        config
      )
      .then(function (response) {
        // alert("success");
        Swal.fire({
          title: "Successful!",
          text: "You Updated Data!",
          icon: "success",
          showConfirmButton: false,
          timer: 2000
        });
        setSupplierList(supplierList.map((item) => {
          if (item._id === id) {
            return response.data.data
          } else {
            return item
          }
        }))
      })
      .catch(function (err) {
        alert(err.message)
      })
    // document.getElementById('description').value = ''
    // document.getElementById('name').value = ''
    //      props.setOpen(false);
  }

  const handleDelete = event => {
    apiInstance
      .delete(
        'supplier/' +
        event
      )
      .then(response => {
        Swal.fire({
          title: 'Success',
          text: 'Successfully Deleted!',
          icon: 'success',
          confirmButtonText: 'OK'
        })
        const result = supplierList.filter(item => item._id !== event)
        setSupplierList(result)
      })
      .catch(error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
          showConfirmButton: false,
          timer: 2000
        })
      })
  }

  const handleUpdate = event => {
    setShowUpdate(true)
    setId(event)
    // console.log(event, 'event')
    const getCatUpdate = async () => {
      try {
        const res = await apiInstance.get(
          'supplier/' +
          event
        )
        // console.log(res.data.data)

        setFormData({
          name: res.data.data?.name,
          phone: res.data.data?.phone,
          address: res.data.data?.address
        })
      } catch (err) { }
    }
    getCatUpdate()

  }
  useEffect(() => {
    const getSupplier = async () => {
      try {

        const res = await apiInstance.get(
          "suppliers"
        );

        setSupplierList(res.data.data);

      } catch (err) { }
    };
    getSupplier();
  }, []);

  return (
    <div classNameName="App">
      {/* <!-- end preloader --> */}
      {/* @include('sweet::alert') */}

      <div className="wrapper">
        {/* <!-- Navbar --> */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          {/* <!-- Left navbar links --> */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#">
                <i className="fas fa-bars"></i>
              </a>
            </li>
          </ul>
          <div className="title">
            <h1>Financial Report</h1>
          </div>

          <ul className="navbar-nav ml-auto"></ul>
        </nav>
        {/* <!-- /.navbar --> */}

        {/* <!-- Main Sidebar Container --> */}
        <SideBar />

        {/* <!-- Content Wrapper. Contains page content --> */}

        <div className="content-wrapper">
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active">
                      Account Type List
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}

          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-8">
                  <div className="card">
                    <div className="card-header">
                      {/* <h3 className="card-title">Cost Center List</h3> */}
                    </div>
                    <div className="card-body">
                      <table id="example1" className="table">
                        <thead className="bg-info">
                          <tr>
                            <th>No</th>

                            <th>Name</th>
                            <th>Phone</th>
                            <th>Address</th>

                            <th className='text-center'>Action</th>
                          </tr>
                        </thead>

                        {supplierList.map((accType, i) => (
                          <tbody className="">
                            <tr>
                              <td>{++i}</td>

                              <td>{accType.name}</td>
                              <td>{accType.phone}</td>
                              <td>{accType.address}</td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  onClick={() => handleUpdate(accType._id)}
                                  class="btn btn-warning btn-sm ml-2">
                                  <FaRegEdit />
                                </button>
                                &nbsp;
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={(e) => handleDelete(accType._id)}>
                                  <FaRegTrashAlt />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>
                  </div>
                </div>

                {showUpdate ? (
                  <div className='col-md-3'>
                    <div className='card px-3 py-3'>
                      <h5 className='card-header mb-4 fw-5 text-secondary'>
                        Update Supplier
                      </h5>

                      <div class='form-group'>
                        <label for='name' className='text-secondary'>
                          Name
                        </label>
                        <input
                          type='text'
                          class='form-control border-info'
                          name='uname'
                          id='uname'
                          value={formData?.name}
                          //   ref={(el) => (this.name = el)}
                          onChange={e => setFormData({ ...formData, name: e.target.value })}
                        />
                      </div>



                      <div class='form-group'>
                        <label for='name' className='text-secondary'>
                          Phone
                        </label>
                        <input
                          type='phone'
                          class='form-control border-info'
                          name='uamount'
                          id='uamount'
                          value={formData?.phone}
                          //   ref={(el) => (this.name = el)}
                          onChange={e => setFormData({ ...formData, phone: e.target.value })}
                        />
                      </div>

                      <div class='form-group'>
                        <label for='name' className='text-secondary'>
                          Address
                        </label>
                        <textarea
                          className='form-control'
                          id='address'
                          name='address'
                          value={formData?.address}
                          //   ref={(el) => (this.description = el)}
                          onChange={e => setFormData({ ...formData, address: e.target.value })}
                        ></textarea>
                      </div>
                      <button
                        className='btn btn-primary form-control text-center fw-5'
                        id='submit'
                        onClick={SupplierUpdate}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className='col-md-3'>
                    <div className='card px-3 py-3'>
                      <h5 className='card-header mb-4 fw-5 text-secondary'>
                        Create Supplier
                      </h5>

                      <div class='form-group'>
                        <label for='name' className='text-secondary'>
                          Supplier Name
                        </label>
                        <input
                          type='text'
                          class='form-control border-info'
                          name='cname'
                          id='cname'
                          //   ref={(el) => (this.name = el)}
                          onChange={e => setFormData({ ...formData, name: e.target.value })}
                        />
                      </div>


                      <div class='form-group'>
                        <label for='name' className='text-secondary'>
                          Phone
                        </label>
                        <input
                          type='number'
                          class='form-control border-info'
                          name='camount'
                          id='camount'
                          //   ref={(el) => (this.name = el)}
                          onChange={e => setFormData({ ...formData, phone: e.target.value })}
                        />
                      </div>

                      <div class='form-group'>
                        <label for='name' className='text-secondary'>
                          Address
                        </label>
                        <textarea
                          className='form-control'
                          id='cdesc'
                          name='cdesc'
                          //   ref={(el) => (this.description = el)}
                          onChange={e => setFormData({ ...formData, address: e.target.value })}
                        />
                      </div>
                      <button
                        className='btn btn-primary form-control text-center fw-5'
                        id='submit'
                        onClick={SupplierCreate}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                )}
              </div>
              {/* <AccTypeUpdate
                updateDialog={updateDialog}
                close={() => setUpdateDialog(false)}
                setUpdateDialog={setUpdateDialog}
                id={id}
                setAccountType={setAccountType}
                accountType={accountType}
              /> */}
            </div>
            {/*<!-- /.container-fluid --> */}
          </section>
        </div>
      </div>

      {/* <!-- /.content-wrapper --> */}
      <footer className="main-footer">
        <strong>
          Copyright &copy; 2017-2020{" "}
          <a href="http://www.kwintechnologies.com">K-win Technology</a>.
        </strong>
        All rights reserved.
      </footer>

      {/* <!-- Control Sidebar --> */}
      <aside classNameName="control-sidebar control-sidebar-dark">
        {/* <!-- Control sidebar content goes here --> */}
      </aside>
      {/* <!-- /.control-sidebar --> */}

      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default Dashboard
